import React from 'react';
import RadioComponent from './RadioComponent';
import Label from './Label';
import Tooltip from './Tooltip';

const PrintConfirmation = (props) => {
  const {
    name,
    parameters,
    onChangeParameter,
    children,
    errorMessage,
  } = props;
  const onChange = (e) => onChangeParameter(name, e.target.value);
  const value = parameters[name];

  return (
    <div className="form-group">
      <Label label={props.label} required={props.required}>
        <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
      </Label>
      <div className="radio-group">
        <RadioComponent
          {...props}
          checked={value === props.noValue}
          inline
          inputId={`print-confirmation-no-${props.groupName}`}
          inputClassName={props.inputClassName}
          label={props.noLabel}
          name={name}
          onChange={onChange}
          value={props.noValue}
          groupName={props.groupName} />
        <RadioComponent
          {...props}
          checked={value === props.yesValue}
          inline
          inputId={`print-confirmation-yes-${props.groupName}`}
          inputClassName={props.inputClassName}
          label={props.yesLabel}
          name={name}
          onChange={onChange}
          value={props.yesValue}
          groupName={props.groupName} />
        <div className="error-place" />
      </div>
      {errorMessage}
      {children}
    </div>
  );
};

PrintConfirmation.defaultProps = {
  name    : 'print_confirmation',
  label   : 'Send me a Check Plot?',
  yesLabel: 'Yes',
  yesValue: '1',
  noLabel : 'No',
  noValue : '0',
  required: true,
};

export default PrintConfirmation;
